module.exports = __webpack_public_path__ + "static/media/cloud-icon.60f1b19c.svg";